import { BaseService } from "./BaseService";
import {
  CreateLegalPageDto,
  LegalPage,
  UpdateLegalPageDto,
} from "@/types/legal-page";

class LegalPagesService extends BaseService {
  private basePath = "/legal-pages";

  async getLegalPages(): Promise<LegalPage[]> {
    return this.get<LegalPage[]>(this.basePath);
  }

  async getLegalPage(key: string): Promise<LegalPage> {
    return this.get<LegalPage>(`${this.basePath}/${key}`, undefined, {
      disableToast: true,
    });
  }

  async createLegalPage(data: CreateLegalPageDto): Promise<LegalPage> {
    return this.post<LegalPage>(this.basePath, data);
  }

  async updateLegalPage(
    key: string,
    data: UpdateLegalPageDto,
  ): Promise<LegalPage> {
    return this.patch<LegalPage>(`${this.basePath}/${key}`, data);
  }
}

export const legalPagesService = new LegalPagesService();
